





























import { Vue, Component, Prop } from 'vue-property-decorator';
import { HSLColor } from '../types/color';

@Component
export default class PaletteColor extends Vue {
  @Prop() color!: HSLColor;

  @Prop() key!: number;

  removeFromPalette(key: number) {
    this.$emit('remove', key);
  }

  copyValue(color: HSLColor) {
    this.$emit('copy', color);
  }

  editColor(color: HSLColor) {
    this.$emit('edit', { ...color });
  }
}
